import { render, staticRenderFns } from "./ScrollToTopButton.vue?vue&type=template&id=7e861991&scoped=true"
import script from "./ScrollToTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollToTopButton.vue?vue&type=script&lang=js"
import style0 from "./ScrollToTopButton.vue?vue&type=style&index=0&id=7e861991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e861991",
  null
  
)

export default component.exports